(function () {
  function initTabs() {
    document.querySelectorAll('.sg-tab').forEach((tab) => {
      if (tab.dataset.bound === 'true') return;
      tab.dataset.bound = 'true';

      tab.addEventListener('click', function () {
        const tabSet = this.closest('[data-sg-tabs]');
        if (!tabSet) return;

        const tabs = tabSet.querySelectorAll('.sg-tab');
        const panels = tabSet.querySelectorAll('.sg-panel');
        const key = this.getAttribute('data-sg-tab');

        tabs.forEach((btn) => {
          const active = btn === this;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
          btn.setAttribute('tabindex', active ? '0' : '-1');
        });

        panels.forEach((panel) => {
          const active = panel.getAttribute('data-sg-panel') === key;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });

      tab.addEventListener('keydown', function (e) {
        const tabSet = this.closest('[data-sg-tabs]');
        if (!tabSet) return;

        const tabs = Array.from(tabSet.querySelectorAll('.sg-tab'));
        const index = tabs.indexOf(this);

        let next = null;

        if (e.key === 'ArrowRight') next = index === tabs.length - 1 ? 0 : index + 1;
        if (e.key === 'ArrowLeft') next = index === 0 ? tabs.length - 1 : index - 1;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;

        if (next !== null) {
          e.preventDefault();
          tabs[next].focus();
          tabs[next].click();
        }
      });
    });
  }

  function initTableHover() {
    document.querySelectorAll('.sg-table').forEach((table) => {
      if (table.dataset.bound === 'true') return;
      table.dataset.bound = 'true';

      function getColumnStart(cell) {
        let column = 0;
        let previousCell = cell.previousElementSibling;

        while (previousCell) {
          column += previousCell.colSpan || 1;
          previousCell = previousCell.previousElementSibling;
        }

        return column;
      }

      table.querySelectorAll('td').forEach((cell) => {
        cell.addEventListener('mouseenter', function () {
          const hoveredColumn = getColumnStart(this);

          table.querySelectorAll('tr').forEach((row) => {
            Array.from(row.children).some((rowCell) => {
              const start = getColumnStart(rowCell);
              const end = start + (rowCell.colSpan || 1);

              if (hoveredColumn >= start && hoveredColumn < end) {
                rowCell.classList.add('highlight-col');
                return true;
              }

              return false;
            });
          });
        });

        cell.addEventListener('mouseleave', function () {
          table.querySelectorAll('.highlight-col').forEach((element) => {
            element.classList.remove('highlight-col');
          });
        });
      });
    });
  }

  function initModelScroll() {
    document.querySelectorAll('.sg-models').forEach((list) => {
      if (list.dataset.bound === 'true') return;
      list.dataset.bound = 'true';

      list.addEventListener('keydown', function (e) {

        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.scrollBy({ left: 160, behavior: 'smooth' });
        }

        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.scrollBy({ left: -160, behavior: 'smooth' });
        }

      });
    });
  }

  function initModelAlignment() {
    document.querySelectorAll('.sg-models').forEach((list) => {
      const guide = list.closest('.sg-guide');
      if (!guide) return;

      const updateModelAlignment = () => {
        list.classList.remove('sg-models--overflow');
        list.style.justifyContent = 'left';

        const isOverflowing = list.scrollWidth > guide.clientWidth;

        if (isOverflowing) {
          list.classList.add('sg-models--overflow');
          list.style.justifyContent = 'left';
        } else {
          list.style.justifyContent = 'center';
        }
      };

      updateModelAlignment();

      window.addEventListener('resize', updateModelAlignment);
    });
  }

  function initSizeGuide() {
    initTabs();
    initTableHover();
    initModelScroll();
    initModelAlignment();

    document.querySelectorAll('.sg-table-scroll').forEach(el => {
      if (el.dataset.boundScroll === 'true') return;
      el.dataset.boundScroll = 'true';
      el.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.scrollBy({ left: 160, behavior: 'smooth' });
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.scrollBy({ left: -160, behavior: 'smooth' });
        }
      });
    });

    // screen reader patch: prevent horizontal jump when SR focuses child items
    document.querySelectorAll('.sg-models').forEach(container => {
      if (container.dataset.preventJump === 'true') return;
      container.dataset.preventJump = 'true';

      let lastGoodScrollLeft = container.scrollLeft;

      // keep track of the most recent known GOOD scroll position
      container.addEventListener('scroll', () => {
        lastGoodScrollLeft = container.scrollLeft;
      }, { passive: true });

      // on focusin (including from screen reader on child <li>), restore after browser tries to shift - important
      container.addEventListener('focusin', (e) => {
        const beforeJump = container.scrollLeft;

        // double RAF: first to let browser do its scrollIntoView, second to override it
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (container.scrollLeft !== beforeJump) {
              container.scrollLeft = beforeJump;  // or lastGoodScrollLeft
            }
          });
        });
      }, true); 
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuide);
  } else {
    initSizeGuide();
  }
})();